interface Props {
    className?: string;
}

export function ArrowLeftIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.9362 11.6094H7.22288L15.4307 4.48438C15.5619 4.36953 15.4823 4.15625 15.3088 4.15625H13.2346C13.1432 4.15625 13.0565 4.18906 12.9885 4.24766L4.13148 11.9328C4.05036 12.0031 3.9853 12.0901 3.94071 12.1877C3.89612 12.2854 3.87305 12.3915 3.87305 12.4988C3.87305 12.6062 3.89612 12.7123 3.94071 12.8099C3.9853 12.9076 4.05036 12.9945 4.13148 13.0648L13.0401 20.7969C13.0752 20.8273 13.1174 20.8438 13.1619 20.8438H15.3065C15.4799 20.8438 15.5596 20.6281 15.4284 20.5156L7.22288 13.3906H20.9362C21.0393 13.3906 21.1237 13.3062 21.1237 13.2031V11.7969C21.1237 11.6937 21.0393 11.6094 20.9362 11.6094Z"
                fill="currentColor"
            />
        </svg>
    );
}
